var _desc, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    role: "img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bank Notes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A solid styled icon from Orion Icon Library.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer2",
    fill: "#8d8ea3",
    d: "M4 45h56v4H4zm0 8h56v4H4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer1",
    d: "M4 7v32h56V7zm12 10h-4a2 2 0 0 1 0-4h4a2 2 0 0 1 0 4zm16 14a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm20 2h-4a2 2 0 0 1 0-4h4a2 2 0 0 1 0 4z",
    fill: "#253858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank1);
export default __webpack_public_path__ + "static/media/bank1.a98934707eb86331a410ffc132e87233.svg";
export { ForwardRef as ReactComponent };